'use client';

import type { FC } from 'react';
import type { SvgProps } from '../entities/Sprite';
import { Fragment } from 'react';
import { usePathname } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import { Icon } from '../entities/Sprite';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '../ui/Breadcrumb/breadcrumb';

export type BreadcrumbItemType = {
  href?: string;
  label: string;
  icon?: SvgProps['name'];
};

interface AppBreadcrumbsProps {
  className?: string;
  items: Array<BreadcrumbItemType>;
}

export const AppBreadcrumbs: FC<AppBreadcrumbsProps> = ({ className, items }) => {
  const pathname = usePathname();
  const activeItem = items.find(item => item.href === pathname);

  return (
    // Hidden from users on mobile but kept in the DOM for crawlers; visible on desktop.
    <Breadcrumb className={cn('sr-only lg:not-sr-only', className)}>
      <BreadcrumbList className="overflow-x-auto w-full flex-nowrap scrollbar-hide">
        {items.map((item, index) => (
          <Fragment key={index}>
            <BreadcrumbItem className={cn('text-lg font-medium leading-5.5 text-c300', activeItem?.href === item.href && 'text-light')}>
              {
                item.icon && <Icon name={item.icon} className="size-6 text-c300" />
              }
              <BreadcrumbLink href={item.href} className="hover:text-light font-medium text-lg tracking-normal whitespace-nowrap leading-5.5">{item.label}</BreadcrumbLink>
            </BreadcrumbItem>
            {index < items.length - 1 && (
              <BreadcrumbSeparator>
                <Icon name="arrow-separator" className="size-4 text-c300" />
              </BreadcrumbSeparator>
            )}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
